import { Avatar, Stack, Typography, TypographyProps } from '@mui/material';
import { ReactNode } from 'react';

type LanguageLabelProps = { langCode: string; langLabel: ReactNode; textColor?: TypographyProps['color'] };

export const LanguageLabel = ({ langCode, langLabel, textColor = 'neutral-550.main' }: LanguageLabelProps) => {
    return (
        <Stack direction={'row'} alignItems={'center'} gap={0.5}>
            <Avatar src={`/static/flags/${langCode}.svg`} className="w-[18px] h-[18px]" />
            <Typography fontSize={16} fontWeight={400} color={textColor ?? 'neutral-550.main'}>
                {langLabel}
            </Typography>
        </Stack>
    );
};
